import { ProductModel } from '@models/product';
import React from 'react';

export const CoupangProducts: React.FC<{ data: ProductModel }> = (props) => {
  const data = props.data;

  if (!data?.coupangProduct || !data?.coupangProduct.products || data?.coupangProduct.products.length === 0) {
    return <div></div>;
  }

  return (
    <div
      style={{
        padding: '24px 16px',
        backgroundColor: 'white',
      }}>
      <div
        style={{
          fontSize: '20px',
          fontWeight: 'bold',
          lineHeight: '26px',
          letterSpacing: -0.6,
          marginBottom: '16px',
        }}>
        {data.coupangProduct.title || '쿠팡에서 준비물 구매하기'}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '16px',
          overflowX: 'auto',
          overflowY: 'hidden',
          paddingBottom: '8px',
          scrollbarWidth: 'thin',
          scrollbarColor: '#ccc transparent',
        }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '16px',
            minWidth: '100%',
          }}>
          {data.coupangProduct.products.map((preparation, index) => (
            <a
              key={index}
              href={preparation.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
              }}>
              <img
                src={preparation.thumbnailImage}
                alt={preparation.thunbnailAltText}
                width={preparation.width}
                height={preparation.height}
                style={{
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              />
            </a>
          ))}
        </div>
      </div>

      <div
        style={{
          fontSize: '12px',
          color: '#66686b',
          textAlign: 'left',
          lineHeight: '18px',
          letterSpacing: -0.2,
        }}>
        쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.
      </div>
    </div>
  );
};
